module.exports = __webpack_public_path__ + "media/images/home/hero_widget_bg_old-99252e4a7927f087967c0a682bc6de67.jpg";